import React from "react";
import CardCursos from "components/CardCursos";

import NivelesCard from "components/Cursos/NivelesCard";
import Header from "components/Header";
import Seo from "components/Seo/Seo";
import CarruselVertical from "components/Carrusel/CarruselVertical";
import WhyCard from "components/Index/WhyCard";
import Galeria from "components/Galeria";
import cursosData from "../data/cursos.json";
import examData from "../data/preparacionExamenes.json";
import Carrusel from "components/Carrusel/Carrusel";
import TestimonialsMarquee from "components/Testimonios/TestimonialsMarquee";

function Cursos() {
  const razones = [
    {
      razon: "Comunicación Eficaz",
      info: "Fomentar la capacidad del estudiante para expresarse con confianza y claridad en entornos cotidianos, académicos y profesionales",
    },
    {
      razon: "Desarrollo Integral de Habilidades",
      info: "Mejorar las competencias de comprensión, expresión oral, lectura y escritura, adaptadas a las necesidades y metas de cada estudiante.",
    },
    {
      razon: "Aplicación Práctica",
      info: "Proporcionar herramientas y estrategias que permitan a los estudiantes utilizar el inglés de manera efectiva en contextos reales.",
    },
    {
      razon: "Evaluación Continua",
      info: "Asegurar un seguimiento del progreso de cada estudiante, ajustando los métodos y contenidos del curso para maximizar su aprendizaje y éxito.",
    },
  ];
  const itemsCursos = cursosData.map((curso, index) => (
    <CardCursos
      key={index}
      curso={curso.titulo}
      descripcion={curso.descripcion}
      url={curso.url}
      img={curso.img}
    />
  ));
  const itemsExamenes = examData.map((item, index) => (
    <CardCursos
      key={index}
      curso={item.titulo}
      descripcion={item.descripcion}
      url={item.url}
      img={item.img}
    />
  ));
  return (
    <>
      <Seo
        title="Cursos de Inglés"
        description="En Brighton encontrarás los cursos perfectos para desarrollar tus habilidades en inglés, trabajar competencias específicas o entrenamientos para certificar tu conocimiento en el idioma."
      />
      <div className="w-full text-left hyphens-auto ">
        <Header
          titulo="Cursos de Inglés"
          classTitulo=" text-sky-200"
          classInfo="text-white"
          info="En Brighton encontrarás los cursos perfectos para desarrollar tus habilidades en inglés, trabajar competencias específicas o entrenamientos para certificar tu conocimiento en el idioma."
          linkToSection="/cursos#info"
          botonDescripcion="Mas Información"
          classBoton="text-primario bg-sky-200 hover:bg-blue-800 hover:bg-blue-600"
          img="https://brightonenglishcenter.edu.co/img/
DSC_0010.jpg"
        />
        <section
          className=" flex flex-col gap-5 m-20 xl:m-40 rounded-30 items-center bg-blue-6"
          id="info"
        >
          <div className="w-full xl:w-3/4 text-left flex flex-col gap-5 items-center space-y-5">
            <h2 className="text-7xl font-bold text-blue-4 font-Bebas ">
              Nos enfocamos en
            </h2>
            <p className="text-xl xl:text-2xl hyphens-none">
              Nuestros cursos están diseñados para que los estudiantes puedan
              desarrollar de manera efectiva las competencias lingüísticas en
              contextos prácticos. Consideramos el nivel de competencia de cada
              estudiante, estableciendo objetivos reales, específicos y
              funcionales que permiten el desarrollo integral de todas las
              habilidades lingüísticas.
            </p>
          </div>
          <div className="w-full xl:w-3/4 flex flex-col gap-5 items-center">
            <div className="grid grid-cols-2 gap-5 ">
              {razones.map((value, index) => (
                <WhyCard
                  key={index}
                  titulo={value.razon}
                  descripcion={value.info}
                  colorPrimario="#fffbeb"
                  shadowColor="#0d2334"
                />
              ))}
            </div>
          </div>
        </section>
        <section className=" bg-blue-200 rounded-30">
          <div className="py-20 xl:p-40 space-y-10">
            <div className="w-3/4 flex flex-col items-center gap-5 mx-auto">
              <h2 className="text-7xl font-bold text-blue-4 font-Bebas text-center">
                Encuentra el curso de inglés ideal para ti.
              </h2>
              <p className="text-xl xl:text-2xl text-center">
                En Brighton encontraras una serie de cursos pensados en
                desarrollar y afianzar todas las habilidades del idioma de
                manera integral, en contextos reales y aplicando metodologías
                dinámicas.
              </p>
            </div>
            <Carrusel items={itemsCursos} />
          </div>
        </section>
        <section className=" flex flex-col gap-5 m-20 mx-0 xl:m-40">
          <div className="w-4/5 flex flex-col gap-5 max-w-6xl mx-auto">
            <h2 className="text-7xl font-bold text-blue-4 font-Bebas">
              Certifica tu inglés y amplia tus horizontes.
            </h2>
            <p className="text-xl hyphens-none xl:text-2xl">
              Nuestros cursos de preparación para exámenes internacionales están
              diseñados para equiparte con las habilidades y la confianza
              necesarias para destacar en estas pruebas cruciales. Ofrecemos
              programas especializados para una variedad de exámenes reconocidos
              mundialmente como <strong>IELTS, TOEFL, OOPT Y APTIS.</strong>
            </p>
          </div>
            <Carrusel items={itemsExamenes} />
          
        </section>
        <CarruselVertical
          outputA="40%"
          outputB="-40%"
          title="Nos basamos en el CEFR para garantizar una excelente formación"
          info="Hemos diseñado un programa de formación con el objetivo de cumplir
            los requerimientos del CEFR (Marco Común Europeo de Referencia) para
            brindarle a nuestros estudiantes educación de calidad."
          // link="https://brightonenglishcenter.edu.co/img/tabla_programa_adultos.png"
        >
          <NivelesCard
            color={`#ff7202`}
            nivel="Nivel Elementary (A1)"
            info="Este nivel es ideal para quienes están comenzando desde cero.
                Está dividido en 4 ciclos de 1 mes cada uno. Al finalizar,
                habrás adquirido las habilidades necesarias para entender y usar
                expresiones cotidianas y frases básicas."
          />
          <NivelesCard
            color={`#FFE500`}
            nivel="Nivel Pre-Intermediate (A2)"
            info="Si ya tienes alguna base, este nivel te ayudará a consolidar tus conocimientos. Está dividido en 5 ciclos de 1 mes cada uno. En el último ciclo, te prepararemos para presentar el examen KET (Key English Test), una certificación reconocida que verificará si tu nivel de inglés está bajo el estándar internacional."
          />
          <NivelesCard
            color={`#71DD06`}
            nivel="Nivel Intermediate (B1)"
            info="Este nivel te ayudará a consolidar tus conocimientos. Está dividido en 5 ciclos de 1 mes cada uno. En el último ciclo, te prepararemos para presentar el examen APTIS General, una certificación de British Council reconocida por el Ministerio Educación. Es aceptada en varios contextos académicos y laborales  del país e internacionales."
          />
          <NivelesCard
            color={`#00b1c9`}
            nivel="Nivel Upper-Intermediate (B2)"
            info="Aquí trabajarás en mejorar tu fluidez y precisión del idioma en un entorno más académico. Este nivel también tiene 5 ciclos de 1 mes cada uno, durante este tiempo te prepararemos para presentar la prueba OOPT (Oxford Online Placement Test). Al finalizar, tendrás la oportunidad de certificar tu inglés con exámenes internacionales como IELTS, TOEFL IBT o APTIS Advanced, que son reconocidos en todo el mundo."
          />
          <NivelesCard
            color={`#0049ff`}
            nivel="Nivel Advanced (C1)"
            info="Este nivel está dirigido a quienes desean alcanzar un alto nivel de competencia en inglés. Está dividido en 4 ciclos de 2 meses cada uno, con una duración total de 8 meses. Requiere conocimientos previos sólidos en el idioma."
          />
          <NivelesCard
            color={`#b100e1`}
            nivel="Nivel Upper-Advanced (C2)"
            info="Este es el nivel más avanzado que ofrecemos, ideal para quienes buscan dominar el inglés casi a nivel nativo. Al igual que el nivel C1, consta de 4 ciclos de 2 meses cada uno, con una duración total de 8 meses. Al finalizar, tendrás la oportunidad de certificar tu nivel con exámenes internacionales como IELTS, TOEFL IBT o APTIS Advanced."
          />
        </CarruselVertical>
        <section className="w-full">
          <TestimonialsMarquee />
        </section>
      </div>
    </>
  );
}

export default Cursos;
